import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({}));

export default useStyles;
